import './ViewProjectOfPerson.css';

// Assets
import iconPhone from 'assets/img/icon/phone-color.png';
import iconEmail from 'assets/img/icon/email-color.png';
import iconT from 'assets/img/icon/letter-t.png';
import iconH from 'assets/img/icon/letter-h.png';
import iconThumbsUp from 'assets/img/icon/thumbs-up.png';
import iconHourGlass from 'assets/img/icon/hour-glass.png';
import iconClockIn from 'assets/img/icon/clock-in.png';
import iconClockOut from 'assets/img/icon/clock-out.png';
import iconRubbishBin from 'assets/img/icon/rubbish-bin.png';
import iconHightPerformance from 'assets/img/icon/triangle-green.png';
import iconMiddlePerformance from 'assets/img/icon/triangle-yellow.png';
import iconLowPerformance from 'assets/img/icon/triangle-red.png';
import iconDuration from 'assets/img/icon/duration.png';
import iconDeadline from 'assets/img/icon/deadline.png';
import iconLocation from 'assets/img/icon/location.png';
import iconSchedule from 'assets/img/icon/schedule.png';
import iconDrawing from 'assets/img/icon/design.png';
import iconPermit from 'assets/img/icon/permit.png';
import iconModel from 'assets/img/icon/hasmodel.png';
import iconAdd from 'assets/img/icon/add.png';
import iconAddNote from 'assets/img/icon/addnote.png';
import iconDays from 'assets/img/icon/days.png';
import iconOpenMenu from 'assets/img/icon/openmenu.png';
import iconCloseMenu from 'assets/img/icon/closemenu.png';
import iconProvideEstimate from 'assets/img/icon/provicequote.png';
import iconPayment from 'assets/img/icon/payment.png';
import iconAlarm from 'assets/img/icon/alarm.png';
	
import companyLogo11		from 'assets/img/logo/11.png';
import companyLogo12		from 'assets/img/logo/12.png';
import companyLogo24		from 'assets/img/logo/24.png';
import companyLogo27		from 'assets/img/logo/27.png';
import companyLogo28		from 'assets/img/logo/28.png';
import companyLogo29		from 'assets/img/logo/29.png';


import React, { Component, useState, useEffect} from 'react';
import Base64	from 'Base64';
import { gapi } from 'gapi-script';
import Switch	from "react-switch";
import Accordion from 'react-bootstrap/Accordion';
import Collapse from 'react-bootstrap/Collapse';
import HorizontalAvatarList from 'components/HorizontalAvatarList';
import { MdSearch } from 'react-icons/md';
import { Form } from 'reactstrap';

import Task		from "./model/Tasks/Task";
import TaskDetail		from "./model/TaskDetails/TaskDetail";
import Invoice		from "./model/Invoices/Invoice";
import Page		from 'components/Page';
import ComboBox from './component/ComboBox';
import {Progress,Input, Modal, ModalBody, ModalFooter, ModalHeader, Badge, Button, ButtonGroup, ButtonToolbar, Card, CardBody, CardHeader, ListGroup, ListGroupItem, CardLink,CardText,CardTitle, Col, DropdownItem, DropdownMenu, DropdownToggle, Row, UncontrolledButtonDropdown, CardFooter, FormGroup, Label } from 'reactstrap';
import SearchInput from 'components/SearchInput';
import { Cookies } from 'react-cookie';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from 'utils/constants';
import DataAdapter from './adapter/DataAdapter';
import Avatar from '../components/Avatar';
import withBadge from '../hocs/withBadge';
import ViewTask from './model/Tasks/ViewTask';

import {
  FloatingMenu,
  MainButton,
  ChildButton,
} from 'react-floating-button-menu';
import MdAdd from '@material-ui/icons/Add';
import MdClose from '@material-ui/icons/Clear';
import MdFavorite	from '@material-ui/icons/Favorite'
import Project		from "./model/Projects/Project";
 
 
const cookie =new Cookies();
const colorMap = {};
const selectedColors = {};


var __PERSON__, __PERSON_ROLE__, __STATUS__,__COLUMNS__;
var __STATUS__		=	"0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25";
var __DEPARTMENT__	=	"-1";

var isNumber = function isNumber(value){
   return typeof value === 'number' && isFinite(value) && value != 'null';
}

var numberWithCommas = (x) => {
    return (x?x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):'');
}

function allowDrop(e) {
	e.preventDefault();
}
const generateColor = (alfa) => {
  let randomColorString = "#";
  const arrayOfColorFunctions = "0123456789abcdef";
  for (let x = 0; x < 6; x++) {
    let index = Math.floor(Math.random() * 16);
    let value = arrayOfColorFunctions[index];

    randomColorString += value;
  }
  return randomColorString + alfa;
};
const newColorFind = (id, alfa) => {
  // If already generated and assigned, return
  if (colorMap[id]) return colorMap[id];

  // Generate new random color
  let newColor;

  do {
    newColor = generateColor(alfa);
  } while(selectedColors[newColor]);

  // Found a new random, unassigned color
  colorMap[id] = newColor;
  selectedColors[newColor] = true;

  // Return next new color
  return newColor;
}

const hasAccess = (__type) => {
	var _result	= false;
	var person_role	=	cookie.get('v-person-role');
	console.log(person_role);
		if (person_role * 1 === 0) { //ADMIN
			if(__type=='budget'){
				_result	=	true;
			}
		}
		if (person_role * 1 === 1 || person_role * 1 === 11) { //MANAGER & PM
			if(__type=='budget'){
				_result	=	true;
			}
		}
		if (person_role * 1 === 2) { //Marketting Specialist
		}
		if (person_role * 1 === 3) { //EMPLOYEE
		}
		if (person_role * 1 === 5) { //Verifier
		}
		if (person_role * 1 === 6) { //Staff
		}
		if (person_role * 1 === 7) { //TRADE PERSON
		}
		if (person_role * 1 === 8) { //CLIENT
		}
		if (person_role * 1 === 9) { //GUEST
		}
	
	return _result;
}

const showTaskList = () =>{
	return(
		<>TEST</>
	)
}

class ViewProjectsOfPerson extends React.Component {
	notificationSystem = React.createRef();

	constructor(props){
		super(props);
		__PERSON__ 		= cookie.get("v-person-id");
		__PERSON_ROLE__ = cookie.get("v-person-role");
        if(props.match){
            __STATUS__		= this.props.match.params.status;
            __DEPARTMENT__	= this.props.match.params.department;
        }else{
            __STATUS__		= this.props.status;
            __DEPARTMENT__	= this.props.department;
        }
		
		__STATUS__		= (__STATUS__		==null?"0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25": __STATUS__);
		//__DEPARTMENT__	= (__DEPARTMENT__	==null?cookie.get("v-department"): __DEPARTMENT__);
		__DEPARTMENT__	= (__DEPARTMENT__	==null? "-1": __DEPARTMENT__);
		
        cookie.set('v-department', __DEPARTMENT__);
		
		this.state = {
			projects			: [], 
			dataset				: [], 
			columns				: __STATUS__.split(','), 
			person				: __PERSON__,  
			status				: __STATUS__, 
			actionModal			: false, 
			loadingStatusForm	: false, 
			statusModal			: false, 
			project_id			:0, 
			project				: [], 
			task_id				:0, 
			task				:[], 
			hasDrawings			:false,
			hasPermit			:false,
			hasModel			:false,
			search				:'',
			isCollapse			:1,
			isCompact			: true,
			};
		this.loadData(__STATUS__, __PERSON__);


	}

	loadData = (_status, _person) => {
		//var query = "SELECT tyyy.rb_type_desc as category_desc, prj.prj_category_1 as category, prj.prj_department,de.rb_type_desc AS department,prj.prj_id, prj.prj_code, prj.prj_title, prj.prj_address, prj.prj_city, ty.rb_type_desc AS prj_status, prj_status as prj_status_id, prj_budget, prj_budget_highest, prj_budget_lowest, prj_posted_date, refered_by_person_id, refered_by_prj_id, pr.* FROM rb_projects prj LEFT JOIN rb_types ty ON ty.rb_type_no = prj.prj_status AND ty.rb_type = 'prj_status' LEFT JOIN rb_types de ON de.rb_type_no=prj.prj_department AND de.rb_type='prj_department' LEFT JOIN rb_person pr ON pr.person_id = prj.client_id LEFT JOIN rb_types tyyy ON (tyyy.rb_type_no = prj.prj_category_1 AND tyyy.rb_type = 'person_trade') ORDER BY ty.rb_type_no, prj.prj_posted_date desc;";
		//var query = "SELECT pt.pt_id,pt.sender_id, pt.receiver_id, p.name AS `receiver` , pt.expected_end_date, pt.start_date, pt.end_date, pt.task_status AS `task_status_id`, tyyyyy.rb_type_desc as `task_status`, tyyyy.rb_type_desc AS `task_type`, pt.percent_done, pt.real_hours, pt.estimate_hours ,tyyy.rb_type_desc as category_desc, prj.prj_category_1 as category, prj.prj_department,de.rb_type_desc AS department,prj.prj_id, prj.prj_code, prj.prj_title, prj.prj_address, prj.prj_city, ty.rb_type_desc AS prj_status, prj_status as prj_status_id, prj_budget, prj_budget_highest, prj_budget_lowest, prj_posted_date, refered_by_person_id, refered_by_prj_id, year(prj_posted_date) as prj_year, pr.* FROM rb_projects prj LEFT JOIN rb_project_tasks pt ON pt.prj_id = prj.prj_id LEFT JOIN rb_types ty ON ty.rb_type_no = prj.prj_status AND ty.rb_type = 'prj_status' LEFT JOIN rb_types de ON de.rb_type_no=prj.prj_department AND de.rb_type='prj_department' LEFT JOIN rb_person pr ON pr.person_id = prj.client_id LEFT JOIN rb_types tyyy ON (tyyy.rb_type_no = prj.prj_category_1 AND tyyy.rb_type = 'person_trade') LEFT JOIN rb_types tyyyy ON (tyyyy.rb_type_no = pt.task_type AND tyyyy.rb_type = 'task_type') LEFT JOIN rb_types tyyyyy ON (tyyyyy.rb_type_no = pt.task_status AND tyyyyy.rb_type = 'task_status') LEFT JOIN rb_person p ON p.person_id = pt.receiver_id ORDER BY ty.rb_type_no, prj.prj_posted_date desc, pt.pt_id;";
		var query = "SELECT sum(if(ptd.task_type=37,1,0)) AS `note_count`,group_concat(if(ptd.task_type=37,concat(DATE_FORMAT(ptd.start_date,'%d %M'),'-',ptd.note),''),'---') AS `note_list`, sum(if(ptd.task_type=98,1,0)) AS `clock_count`,group_concat(if(ptd.task_type=113,concat(DATE_FORMAT(ptd.expected_start_date,'%d %M'),' ',ptd.note),''),'---') AS `alarm_list`,pt.pt_id, pt.parent, pt.task, pt.task_description, pt.sender_id, pt.receiver_id, pt.item_no, pt.task_no, p.name AS `receiver` , pt.expected_end_date, DATE_FORMAT(CONVERT_TZ(pt.start_date,@@session.time_zone,'-04:00'),'%d %M %H:%i') AS `start_date`, pt.start_date AS `start_date_full`, DATE_FORMAT(CONVERT_TZ(pt.end_date,@@session.time_zone,'-04:00'),'%d %M %H:%i') AS `end_date`, pt.end_date AS `end_date_full`, pt.task_status AS `task_status_id`, tyyyyy.rb_type_desc as `task_status`, pt.task_type AS `task_type_id`, tyyyy.rb_type_desc AS `task_type`, pt.percent_done, pt.real_hours, pt.estimate_hours , tyyy.rb_type_desc as category_desc, prj.prj_category_1 as category, prj.prj_department,de.rb_type_desc AS department,prj.prj_id, prj.prj_code, prj.prj_title, prj.prj_desc, prj.prj_address, prj.prj_city, ty.rb_type_desc AS prj_status, prj_status as prj_status_id, prj.prj_budget, prj.prj_budget_highest, prj.prj_budget_lowest, DATE_FORMAT(CONVERT_TZ(prj.prj_posted_date,@@session.time_zone,'-04:00'),'%d %M') AS prj_posted_date, prj.prj_posted_date as `prj_posted_date_full`, prj.refered_by_person_id, prj.refered_by_prj_id, year(prj_posted_date) as prj_year, prj.has_drawings, prj.has_permit,prj.has_model, prj.prj_folder_id, prj.prj_category_1, prj.prj_category_2, prj.prj_category_3, pde.rb_type_desc as prj_department, cr.rb_type_no AS close_reason_id, cr.rb_type_desc AS close_reason, pr.lastname,pr.name, pr.person_tel, pr.email FROM rb_projects prj LEFT JOIN rb_types pde ON (pde.rb_type='prj_department' AND prj.prj_department = pde.rb_type_no) LEFT JOIN rb_types cr ON (cr.rb_type='close_reason' AND prj.close_reason = cr.rb_type_no) LEFT JOIN rb_project_tasks pt ON pt.prj_id = prj.prj_id LEFT JOIN rb_project_task_details ptd ON ptd.pt_id = pt.pt_id LEFT JOIN rb_types ty ON ty.rb_type_no = prj.prj_status AND ty.rb_type = 'prj_status' LEFT JOIN rb_types de ON de.rb_type_no=prj.prj_department AND de.rb_type='prj_department' LEFT JOIN rb_person pr ON pr.person_id = prj.client_id LEFT JOIN rb_types tyyy ON (tyyy.rb_type_no = prj.prj_category_1 AND tyyy.rb_type = 'person_trade') LEFT JOIN rb_types tyyyy ON (tyyyy.rb_type_no = pt.task_type AND tyyyy.rb_type = 'task_type') LEFT JOIN rb_types tyyyyy ON (tyyyyy.rb_type_no = pt.task_status AND tyyyyy.rb_type = 'task_status') LEFT JOIN rb_person p ON p.person_id = pt.receiver_id LEFT JOIN rb_types tyyyyyy ON (tyyyyyy.rb_type_no = ptd.task_type AND tyyyyyy.rb_type='task_type') WHERE pt.task_status IN (7,8,9,10,12) AND prj.prj_department LIKE '" + (__DEPARTMENT__*1==-1? "%%": __DEPARTMENT__) + "' AND " + (__PERSON_ROLE__*1==0 || __PERSON_ROLE__*1==1 || __PERSON_ROLE__*1==10? "true":"pt.receiver_id=" + __PERSON__) + " GROUP BY pt.pt_id ORDER BY ty.rb_type_no, prj.prj_posted_date desc, pt.sort_id;";
		//var query = "call sp_projects_dashboard(" + __DEPARTMENT__ + ", " + __PERSON__ + ");";
		var dataAdapter =new DataAdapter(query);
			dataAdapter.getRecords()
			.then(response=>{
				this.setState({projects : response, dataset : response});
			})

		dataAdapter =new DataAdapter("SELECT * FROM rb_types WHERE rb_type ='prj_status';");
			dataAdapter.getRecords()
			.then(response=>{
				this.setState({prj_status_array : response});
			})

	}

    componentDidUpdate(prevProps, prevState, snapshot){
        if (this.props.status != prevProps.status) {
			this.setState({person : prevProps.person,  status : prevProps.status});
			this.loadData(prevProps.status, prevProps.person);
		}
    }
	
	onClearFilter		=	(e) =>{
		e.persist();
		this.setState({projects	:	this.state.dataset})

	}
	onFilterChange 		=	(e) =>{
		e.persist();
		var projects = this.state.dataset;
		var valueField	=	e.target.attributes[0].value;
		this.setState({projects	:	projects.filter(p=>p[valueField]==e.target.value || e.target.value==-1)})
		//this.setState({dataset	:	projects.filter(p=>p[valueField]==e.target.value || e.target.value==-1)})
	}
	onFromDateChange	=	(e) =>{
		e.persist();
		var projects = this.state.projects;
		var valueField	=	e.target.attributes[0].value;
		this.setState({projects	:	projects.filter(p=>p["start_date"]>=e.target.value || p["end_date"]>=e.target.value )})
		//this.setState({dataset	:	projects.filter(p=>p[valueField]>=e.target.value )})
	}
	onToDateChange		=	(e) =>{
		e.persist();
		var projects = this.state.projects;
		var valueField	=	e.target.attributes[0].value;
		this.setState({projects	:	projects.filter(p=>p["start_date"]<=e.target.value || p["end_date"]<=e.target.value  )})
		//this.setState({dataset	:	projects.filter(p=>p[valueField]<=e.target.value )})
	}
	onHasDrawings		=	( ) =>{
		
		var projects = this.state.dataset;		
		if(!this.state.hasDrawings)
			this.setState({projects	:	projects.filter(p=>p["has_drawings"]*1==1)});
		else
			this.setState({projects	:	projects});
		
		this.setState({hasDrawings : !this.state.hasDrawings});
	}
	onHasPermit			=	( ) =>{
		
		var projects = this.state.dataset;		
		if(!this.state.hasPermit)
			this.setState({projects	:	projects.filter(p=>p["has_permit"]*1==1)});
		else
			this.setState({projects	:	projects});
		
		this.setState({hasPermit : !this.state.hasPermit});
	}
	onHasModel			=	( ) =>{
		
		var projects = this.state.dataset;		
		if(!this.state.hasModel)
			this.setState({projects	:	projects.filter(p=>p["has_model"]*1==1)});
		else
			this.setState({projects	:	projects});
		
		this.setState({hasModel : !this.state.hasModel});
	}
	
	
	render(){
		var projects = this.state.projects;
		return (
			<Page className="DashboardPage" title="" >
					<Row>
						<Col lg={12} md={12} sm={12} xs={12} >
							<FormGroup row >
								<Col md={5}>
									<Form inline className="cr-search-form" onSubmit={e => e.preventDefault()}>
									  <MdSearch
										size="20"
										className="cr-search-form__icon-search text-secondary"
									  />
									  <Input
										type="search"
										className="cr-search-form__input"
										placeholder="Search..."
										onBlur={(e)=>{this.setState({fullText : e.target.value});}}
									  />
									<Button className="ml-1" color="primary" onClick={(e)=>{
										var _text	=	this.state.fullText;
										if(_text!=''){
											var _criteria	=	"(" + 
											"prj.prj_id='" + _text + "'" + 
											" OR prj.prj_title LIKE '% " + _text + " %'" +
											" OR prj.prj_desc LIKE '% " + _text + " %'" +
											" OR prj.prj_address LIKE '% " + _text + " %'" +
											" OR prj.prj_city LIKE '% " + _text + " %'" +
											" OR pr.name LIKE '%" + _text + "%'" +
											" OR pr.lastname LIKE '%" + _text + "%'" +
											" OR pr.person_tel = '" + _text + "'" +
											") AND ";
											var query = "SELECT sum(if(ptd.task_type=37,1,0)) AS `note_count`,group_concat(if(ptd.task_type=37,concat(DATE_FORMAT(ptd.start_date,'%d %M'),'-',ptd.note),''),'---') AS `note_list`, sum(if(ptd.task_type=98,1,0)) AS `clock_count`,group_concat(if(ptd.task_type=113,concat(DATE_FORMAT(ptd.expected_start_date,'%d %M'),' ',ptd.note),''),'---') AS `alarm_list`,pt.pt_id, pt.parent, pt.task, pt.task_description, pt.sender_id, pt.receiver_id, pt.item_no, pt.task_no, p.name AS `receiver` , pt.expected_end_date, DATE_FORMAT(CONVERT_TZ(pt.start_date,@@session.time_zone,'-04:00'),'%d %M %H:%i') AS `start_date`, pt.start_date AS `start_date_full`, DATE_FORMAT(CONVERT_TZ(pt.end_date,@@session.time_zone,'-04:00'),'%d %M %H:%i') AS `end_date`, pt.end_date AS `end_date_full`, pt.task_status AS `task_status_id`, tyyyyy.rb_type_desc as `task_status`, pt.task_type AS `task_type_id`, tyyyy.rb_type_desc AS `task_type`, pt.percent_done, pt.real_hours, pt.estimate_hours , tyyy.rb_type_desc as category_desc, prj.prj_category_1 as category, prj.prj_department,de.rb_type_desc AS department,prj.prj_id, prj.prj_code, prj.prj_title, prj.prj_desc, prj.prj_address, prj.prj_city, ty.rb_type_desc AS prj_status, prj_status as prj_status_id, prj.prj_budget, prj.prj_budget_highest, prj.prj_budget_lowest, DATE_FORMAT(CONVERT_TZ(prj.prj_posted_date,@@session.time_zone,'-04:00'),'%d %M') AS prj_posted_date, prj.prj_posted_date as `prj_posted_date_full`, prj.refered_by_person_id, prj.refered_by_prj_id, year(prj_posted_date) as prj_year, prj.has_drawings, prj.has_permit,prj.has_model, prj.prj_folder_id, prj.prj_category_1, prj.prj_category_2, prj.prj_category_3, pde.rb_type_desc as prj_department, cr.rb_type_no AS close_reason_id, cr.rb_type_desc AS close_reason, pr.lastname,pr.name, pr.person_tel, pr.email FROM rb_projects prj LEFT JOIN rb_types pde ON (pde.rb_type='prj_department' AND prj.prj_department = pde.rb_type_no) LEFT JOIN rb_types cr ON (cr.rb_type='close_reason' AND prj.close_reason = cr.rb_type_no) LEFT JOIN rb_project_tasks pt ON pt.prj_id = prj.prj_id LEFT JOIN rb_project_task_details ptd ON ptd.pt_id = pt.pt_id LEFT JOIN rb_types ty ON ty.rb_type_no = prj.prj_status AND ty.rb_type = 'prj_status' LEFT JOIN rb_types de ON de.rb_type_no=prj.prj_department AND de.rb_type='prj_department' LEFT JOIN rb_person pr ON pr.person_id = prj.client_id LEFT JOIN rb_types tyyy ON (tyyy.rb_type_no = prj.prj_category_1 AND tyyy.rb_type = 'person_trade') LEFT JOIN rb_types tyyyy ON (tyyyy.rb_type_no = pt.task_type AND tyyyy.rb_type = 'task_type') LEFT JOIN rb_types tyyyyy ON (tyyyyy.rb_type_no = pt.task_status AND tyyyyy.rb_type = 'task_status') LEFT JOIN rb_person p ON p.person_id = pt.receiver_id LEFT JOIN rb_types tyyyyyy ON (tyyyyyy.rb_type_no = ptd.task_type AND tyyyyyy.rb_type='task_type') WHERE " + 
											_criteria + (__PERSON_ROLE__*1==0 || __PERSON_ROLE__*1==1 || __PERSON_ROLE__*1==10? "true":"pt.receiver_id=" + __PERSON__) + " GROUP BY pt.pt_id ORDER BY ty.rb_type_no, prj.prj_posted_date desc, pt.sort_id;";
											var dataAdapter =new DataAdapter(query);
												dataAdapter.getRecords()
												.then(response=>{
													this.setState({projects : response, dataset : response});
												});
										}else{
											this.loadData(__STATUS__, __PERSON__);											
										}
									}} >Find</Button>
									</Form>
								</Col>
							</FormGroup>									
						</Col>
						<Col className="d-none" lg={3} md={3} sm={12} xs={12} >
							<Filter filter={this.state.columns} text="Year" displayField="prj_year" valueField="prj_year" projects={this.state.dataset} onFilterChange={this.onFilterChange} />&nbsp;
						</Col>
						<Col className="d-none" lg={3} md={3} sm={12} xs={12} >
							<Filter filter={this.state.columns} text="Department" displayField="department" valueField="prj_department" projects={this.state.dataset} onFilterChange={this.onFilterChange} />&nbsp;
						</Col>
						<Col className="d-none" lg={3} md={3} sm={12} xs={12} >
							<Filter filter={this.state.columns} text="Category" displayField="category_desc" valueField="category" projects={this.state.dataset} onFilterChange={this.onFilterChange} />&nbsp;
						</Col>
						<Col className="d-none" lg={3} md={3} sm={12} xs={12} >
							<Filter filter={this.state.columns} text="Person" displayField="receiver" valueField="receiver_id" projects={this.state.dataset} onFilterChange={this.onFilterChange} />&nbsp;
						</Col>
						<Col className="d-none" lg={3} md={3} sm={3} xs={3} >							
								<Switch height={20} width={50} onChange={()=>{this.setState({isCollapse : !this.state.Collapse});}} checked={this.state.isCollapse}  /><span>Has Estimate</span>
						</Col>
						
						<Col className="d-none" lg={3} md={3} sm={3} xs={3} >							
								<Switch height={20} width={50} onChange={()=>{this.onHasDrawings();}} checked={this.state.hasDrawings} /><span>Has Drawings</span>
						</Col>
						<Col className="d-none" lg={3} md={3} sm={3} xs={3} >							
								<Switch height={20} width={50} onChange={()=>{this.onHasPermit();}} checked={this.state.hasPermit} /><span>Has Permit</span>
						</Col>
						<Col className="d-none" lg={3} md={3} sm={3} xs={3} >							
								<Switch height={20} width={50} onChange={()=>{this.onHasModel();}} checked={this.state.hasModel} /><span>Has Model</span>
						</Col>
						<Col className="d-none" lg={3} md={3} sm={3} xs={3} >							
								<Switch height={20} width={50} onChange={()=>{this.onHasEstimate();}} checked={this.state.hasEstimate}  /><span>Has Estimate</span>
						</Col>
						<Col className="d-none" lg={6} md={6} sm={6} xs={12} >
							<Input text="start_date" type={'date'} onChange={this.onFromDateChange} />
						</Col>
						<Col className="d-none" lg={6} md={6} sm={6} xs={12} >
							<Input text="end_date" type={'date'} onChange={this.onToDateChange} />
						</Col>
				</Row>
				<Row>					
					<Col lg={12} md={12} sm={12} xs={12} >
						<Grid isCompact={this.isCompact} isCollapse={this.state.isCollapse} clockIn={(event, _projects)=>this.onClockInHandler(event, _projects)} clockOut={(event, _projects)=>this.onClockOutHandler(event, _projects)} callback={this.callback} columns={this.state.columns} projects={this.state.projects} onActionHanlder={(e)=>{this.onActionHanlder(e)}} onStatusHanlder={(e)=>{this.onStatusHanlder(e)}} drag={(e)=>{this.drag(e)}} drop={(e)=>{this.drop(e)}}  />
					</Col>
				</Row>	
				<NotificationSystem ref={this.notificationSystem} style={NOTIFICATION_SYSTEM_STYLE}/>
				{this.statusForm()}
			</Page>
				);
	}

    addNotification (_MESSAGE_) {
		const notification = this.notificationSystem.current;
		notification.addNotification({
		  message: _MESSAGE_,
		  level: 'success'
		});
	};	

	onStatusHanlder				=	(e)=>{
		e.persist();
		if(this.state.statusModal){
			this.setState({statusModal: false});
		}else{
			this.setState({
				statusModal				:	true,
				loadingStatusForm		:	true,
				prj_id				:	e.target.attributes[0].value,
				prj_status			:	e.target.attributes[1].value,
				prj_department		:	e.target.attributes[2].value,
			});
		}
	}
	onActionHanlder				=	(e)=>{
		e.persist();
		
		if(this.state.actionModal){
			this.setState({actionModal: false});
		}else{
			this.setState({
				task				:	this.state.projects.filter(p=>p.pt_id*1 == e.target.attributes["data-task-id"].nodeValue*1)[0], 
				actionModal			:	true,
				task_id				:	e.target.attributes["data-task-id"].nodeValue,
				project_id			:	e.target.attributes["data-project-id"].nodeValue,
				});
		}
	}
	onProjectStatusChnageHandler=	(e)=>{
		var _projects	= this.state.projects;
		var _index	= _projects.findIndex(p=>p.prj_id == this.state.prj_id);
		_projects[_index].prj_status_id =	e.target.value*1;
		_projects[_index].prj_status =	this.state.prj_status_array.find(s=>s.rb_type_no*1 == _projects[_index].prj_status_id*1).rb_type_desc;

		this.setState({ projects	: _projects});
		this.setState({	project		: _projects[_index]});

		this.runQuery("UPDATE rb_projects SET prj_status = '" + e.target.value + "',finish_date=now(),close_date=now() WHERE prj_id=" + this.state.prj_id, 'Project Status Updated!');

	}
	onPreStatus					=	(e)=>{
		var _projects	= this.state.projects;
		var _index	= _projects.findIndex(p=>p.prj_id == this.state.prj_id);
		_projects[_index].prj_status_id =	_projects[_index].prj_status_id*1 -1;
		_projects[_index].prj_status =	this.state.prj_status_array.find(s=>s.rb_type_no*1 == _projects[_index].prj_status_id*1).rb_type_desc;

		var _project	= this.state.project;
		_project.prj_status	= _projects[_index].prj_status_id*1;

		this.runQuery("UPDATE rb_projects SET prj_status = prj_status-1 WHERE prj_id=" + this.state.prj_id, "Project Status changed");

		this.setState({ projects : _projects, project : _project});
	}
	onNxtStatus					=	(e)=>{
		var _projects	= this.state.projects;
		var _index	= _projects.findIndex(p=>p.prj_id == this.state.prj_id);
		_projects[_index].prj_status_id =	_projects[_index].prj_status_id*1 +1;
		_projects[_index].prj_status =	this.state.prj_status_array.find(s=>s.rb_type_no*1 == _projects[_index].prj_status_id*1).rb_type_desc;

		var _project	= this.state.project;
		_project.prj_status	= _projects[_index].prj_status_id*1;

		this.runQuery("UPDATE rb_projects SET prj_status = prj_status+1 WHERE prj_id=" + this.state.prj_id, "Project Status changed");

		this.setState({ projects : _projects, project : _project});
	}
	onHoldHandler				=	(e)=>{
		var _projects	= this.state.projects;
		var _index	= _projects.findIndex(p=>p.prj_id == this.state.prj_id);
		_projects[_index].prj_status_id =	12;
		_projects[_index].prj_status =	this.state.prj_status_array.find(s=>s.rb_type_no*1 == _projects[_index].prj_status_id*1).rb_type_desc;
		
		var _project	= this.state.project;
		_project.prj_status	= _projects[_index].prj_status_id*1;

		this.runQuery("UPDATE rb_project_tasks SET task_status = 12 WHERE prj_id=" + this.state.prj_id, "Task has been holded");
		this.runQuery("UPDATE rb_projects SET prj_status = 12 WHERE prj_id=" + this.state.prj_id, "Project has been holded");

		this.setState({ projects : _projects, project : _project, modal : false});
	}
	onCloseHandler				=	(e)=>{
		e.persist();
		var _projects	= this.state.projects;
		var _index	= _projects.findIndex(p=>p.prj_id == this.state.prj_id);
		_projects[_index].prj_status_id =	_projects[_index].prj_status_id*1 + 13;
		_projects[_index].prj_status =	this.state.prj_status_array.find(s=>s.rb_type_no*1 == _projects[_index].prj_status_id*1).rb_type_desc;
		
		var _project	= this.state.project;
		_project.prj_status	= _projects[_index].prj_status_id*1;

		this.runQuery("UPDATE rb_project_tasks SET task_status = 10 WHERE prj_id=" + this.state.prj_id, "Task has been closed");
		this.runQuery("UPDATE rb_projects SET prj_status = prj_status + 13 WHERE prj_id=" + this.state.prj_id, "Project has been closed");

		this.setState({ projects : _projects, project : _project, modal : false});
	}
	onChangeTaskStatus			=	(e)=>{
		e.persist();
		var task =new Task();
		task.changeStatus(e.target.attributes["data-id"].nodeValue, e.target.attributes["data-status-id"].nodeValue);
		//props.onChangeTaskStatus(e);
		this.addNotification("Task status changed", "info");
	}
	onClockInHandler=(e, _project)=>{
		e.persist();

		var _UTC_ = (new Date()).toISOString().split('T')[0] + ' ' + (new Date()).toISOString().split('T')[1].slice(0, 5);
		var	sql ="INSERT INTO rb_project_task_details ( pt_id, prj_id, task_status, task_type, sender_id, receiver_id, Clock_in ) values " +
				"(" + e.target.attributes["data-task-id"].nodeValue + ", " + e.target.attributes["data-project-id"].nodeValue + ", 9 , 98 , " + cookie.get('v-person-id') + "," + cookie.get('v-person-id') + ", '" + _UTC_ + "')" ;

		this.runQuery( sql, "Clocked In", "success");
		//this.runQuery("UPDATE rb_project_tasks SET task_status = 9 WHERE pt_id=" + e.target.attributes["data-task-id"].nodeValue, "Task status has been updated", "info");

		// this.setState({actionModal: true});

		this.setState({ projects : _project});

	}
	onClockOutHandler=(e, _project)=>{
		e.persist();
		var _UTC_ = (new Date()).toISOString().split('T')[0] + ' ' + (new Date()).toISOString().split('T')[1].slice(0, 5);
		var sql	=	"UPDATE rb_project_task_details SET percent_done=100,note='', task_status = 10, Clock_out = '" + _UTC_ + "', real_hours = TIMESTAMPDIFF(MINUTE, Clock_in, '" + _UTC_ + "') " +
		"WHERE task_status=9 AND pt_id=" + e.target.attributes["data-task-id"].nodeValue + " AND task_type=98 AND sender_id=" + cookie.get('v-person-id') + " ORDER BY ptd_id DESC limit 1;";
		this.runQuery(sql, "Clock Out", "error");		

		 sql	=	"UPDATE rb_project_tasks SET real_hours = (" +
					"SELECT sum(TIMESTAMPDIFF(MINUTE, Clock_in, Clock_out)) FROM `rb_project_task_details`" +
					"WHERE pt_id = " + e.target.attributes["data-task-id"].nodeValue + " AND task_status=10 AND task_type=98 AND sender_id=" + cookie.get('v-person-id') + "), percent_done = (select sum(percent_done) from rb_project_task_details WHERE pt_id = " + e.target.attributes["data-task-id"].nodeValue + " AND task_status=10 AND task_type=98 AND sender_id=" + cookie.get('v-person-id') + ") where pt_id = " + e.target.attributes["data-task-id"].nodeValue  + ";";

		//this.runQuery(sql, "Real hours calculated", "info");		
		// this.setState({actionModal: false});
		var _index	= _project.findIndex(p=>p.pt_id == e.target.attributes['data-task-id'].nodeValue);
		//_project[_index].percent_done	 = 100;
		this.setState({ projects : _project});

	}

	statusForm					= 	() => {
		if(this.state.loadingStatusForm){
			/*
			var query = "SELECT * FROM rb_projects WHERE prj_id=" + this.state.prj_id;
			var dataAdapter =new DataAdapter(query);
				dataAdapter.getRecords()
				.then(response=>{
					this.setState({project : response[0], loadingStatusForm : false});
				})	
			*/
			var _projects	= this.state.projects;
			var _index	= _projects.findIndex(p=>p.prj_id == this.state.prj_id);
			this.setState({project : _projects[_index], loadingStatusForm : false});
		}
		
		return (
			<>
				<Modal isOpen={this.state.statusModal} >
					<ModalHeader>
						<Row>
							<Col>
								<b>#{this.state.prj_id}</b> <small>{this.state.project.prj_title}</small>
							</Col>
							<Col>						
								<button type="button" className="btn btn-primary btn-sm float-right ml-1 mr-1" onClick={(event)=>{this.setState({statusModal : false})}} >X</button>{' '}
							</Col>
						</Row>
					</ModalHeader>
					<ModalBody>
						<b>Status : </b>
						<ComboBox defaultValue={this.state.project.prj_status_id}  onChange={this.onProjectStatusChnageHandler}  table="rb_types" valueField="rb_type_no" displayField="rb_type_desc" filterField="rb_type" filterValue="prj_status" orderby="rb_type_desc" />
							{this.state.project.prj_status_id*1>10?
							<>
						<b>Reason : </b>
						<ComboBox defaultValue={this.state.project.close_reason_id}   table="rb_types" valueField="rb_type_no" displayField="rb_type_desc" filterField="rb_type" filterValue="close_reason" orderby="rb_type_desc" onChange={(e)=>{
							
							var _projects	= this.state.projects;
							var _index	= _projects.findIndex(p=>p.prj_id == this.state.prj_id);
							_projects[_index].close_reason_id 	=	e.target.value*1;
							_projects[_index].close_reason 		=	e.target.selectedOptions[0].innerText;

							this.setState({ projects	: _projects});

							this.runQuery("UPDATE rb_projects SET close_reason = '" + e.target.value + "',finish_date=now(),close_date=now() WHERE prj_id=" + this.state.prj_id, 'Project Close Reason Updated!');
							
						}} />
						</>
							:''}
					</ModalBody>
					{/*
					<ModalBody>
						<button id={'pre'} type="button" className="btn btn-outline-secondary btn-sm" onClick={(event) => { this.onPreStatus(event) }} >Pre Status</button>{'	'}
						<button id={'nxt'} type="button" className="btn btn-outline-secondary btn-sm" onClick={(event) => { this.onNxtStatus(event) }} >Next Status</button>{'	'}
						<button type="button" className="btn btn-outline-info btn-sm" onClick={(event) => { this.onHoldHandler(event) }} >Hold/Stop the Job</button>{'	'}
						<button type="button" className="btn btn-outline-danger btn-sm" onClick={(event) => { this.onCloseHandler(event) }} >Close the Job</button>{'	'}
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={(e)=>{this.setState({statusModal:false})}} >Close</Button>{' '}
					</ModalFooter>
					*/}
				</Modal>
			</>
		);
	}
	runQuery					=	(query, message)=>{
		let formData = new FormData();
		formData.append("query", query);
		let requestOptions = {method: 'POST',headers: {'Authorization':'Basic ' + Base64.btoa('sizotech:IsKfs$m$SZV#4Eprtj7zSPbO')},body : formData};
		fetch('https://renobuilding.ca/wp-json/reno/v1/query/' , requestOptions)
			.then(response => {
				return Promise.all([response.json(),response])
			})
			.then(([responseData,response]) => {
				this.addNotification(message);
					
			})
			.catch(error => {
				console.error('Error:', error);
			})		
	}
	drag						=	(e) => {
		e.persist();
		if(this.state.projects){
			e.dataTransfer.setData("text", e.target.id);
		}
	}
	drop						=	(e) => {
		e.persist();
		if(e.target.attributes['status']){
			var _prj_id = e.dataTransfer.getData("text");
			var _projects	= this.state.projects;
			var _index	= _projects.findIndex(p=>p.prj_id == _prj_id);
			_projects[_index].prj_status = e.target.attributes['status'].nodeValue;
			_projects[_index].prj_status_id = e.target.attributes['status-id'].nodeValue;
			this.setState({ projects : _projects});
			this.runQuery("UPDATE rb_projects SET prj_status = " + e.target.attributes['status-id'].nodeValue + " WHERE prj_id=" + _prj_id, "Project status has been updated");
		}
	  }
	callback					=   (obj)	=>{
		var _projects	= this.state.projects;
		if(obj.callbackType == 'note'){
				var _index	= _projects.findIndex(p=>p.pt_id == obj.response[0].pt_id);
				if(_index!=-1){
					_projects[_index].task_status_id = 9;
					_projects[_index].task_status = "In Progress";
					this.runQuery("UPDATE rb_project_tasks SET task_status=9, expected_end_date=now() WHERE pt_id=" + obj.response[0].pt_id,"The task status updated");
				}
				this.setState({ projects : _projects});
		}
		if(obj.callbackType == 'assign'){
				var _index	= _projects.findIndex(p=>p.pt_id == obj.response[0].pt_id);
				if(_index!=-1){
					_projects[_index].task_type = obj.response[0].task_type_desc;
					_projects[_index].task_status_id = obj.response[0].task_status;
					_projects[_index].task_status = obj.response[0].task_status_desc;
				}else{
					var _index	= _projects.findIndex(p=>p.prj_id == obj.response[0].prj_id);
					var __projects	=	JSON.parse(JSON.stringify(_projects));
					var newProject	=	__projects[_index];	
					newProject.pt_id			=	obj.response[0].pt_id;
					newProject.task_status_id	=	obj.response[0].task_status_id;
					newProject.task_status		=	obj.response[0].task_status;
					newProject.task_type_id		=	obj.response[0].task_type_id;
					newProject.task_type		=	obj.response[0].task_type;
					newProject.task				=	obj.response[0].task;
					newProject.task_description	=	obj.response[0].task_description;
					newProject.sender_id		=	obj.response[0].sender_id;
					newProject.receiver_id		=	obj.response[0].receiver_id;
					newProject.receiver			=	obj.response[0].receiver;
					_projects.push(newProject)
				}
				this.setState({ projects : _projects});
		}
		if(obj.callbackType == 'status'){
				var _index	= _projects.findIndex(p=>p.pt_id == obj.response[0].pt_id);
				if(_index!=-1){
					_projects[_index].task_type = obj.response[0].task_type_desc;
					_projects[_index].task_status_id = obj.response[0].task_status;
					_projects[_index].task_status = obj.response[0].task_status_desc;
				}
				this.setState({ projects : _projects});
		}
		if(obj.callbackType == 'clockout'){
			var _UTC_ = (new Date()).toISOString().split('T')[0] + ' ' + (new Date()).toISOString().split('T')[1].slice(0, 5);
			var sql	=	"UPDATE rb_project_task_details SET percent_done=100,note='', task_status = 10, Clock_out = '" + _UTC_ + "', real_hours = TIMESTAMPDIFF(MINUTE, Clock_in, '" + _UTC_ + "') " +
			"WHERE task_status=9 AND pt_id=" + obj.response[0].pt_id + " AND task_type=98 AND sender_id=" + cookie.get('v-person-id') + ";";
			this.runQuery(sql, "Clocked Out")
		}
	/*
			var _projects	= this.state.projects;
			try{
				var _index	= _projects.findIndex(p=>p.pt_id == obj[0].pt_id);
				if(_index!=-1){
					_projects[_index].task_type = obj[0].task_type_desc;
					_projects[_index].task_status_id = obj[0].task_status;
					_projects[_index].task_status = obj[0].task_status_desc;
				}else{
					var _index	= _projects.findIndex(p=>p.prj_id == obj[0].prj_id);
					var __projects	=	JSON.parse(JSON.stringify(_projects));
					var newProject	=	__projects[_index];	
					newProject.pt_id			=	obj[0].pt_id;
					newProject.task_status_id	=	obj[0].task_status_id;
					newProject.task_status		=	obj[0].task_status;
					newProject.task_type_id		=	obj[0].task_type_id;
					newProject.task_type		=	obj[0].task_type;
					newProject.task				=	obj[0].task;
					newProject.task_description	=	obj[0].task_description;
					newProject.sender_id		=	obj[0].sender_id;
					newProject.receiver_id		=	obj[0].receiver_id;
					_projects.push(newProject)
				}
				this.setState({ projects : _projects});
		}catch(e){
			var _UTC_ = (new Date()).toISOString().split('T')[0] + ' ' + (new Date()).toISOString().split('T')[1].slice(0, 5);
			var sql	=	"UPDATE rb_project_task_details SET percent_done=100,note='', task_status = 10, Clock_out = '" + _UTC_ + "', real_hours = TIMESTAMPDIFF(MINUTE, Clock_in, '" + _UTC_ + "') " +
			"WHERE task_status=9 AND pt_id=" + obj.pt_id + " AND task_type=98 AND sender_id=" + cookie.get('v-person-id') + ";";
			console.log(sql)
			this.addNotification("Clocked Out", "info");
		}
		*/	
	}
}

export const Filter		= (props) =>{
	console.log(props.filter)
	var projects = props.projects;
	var tempValue	=	[];
	var displayField	=	props.displayField;
	var valueField		=	props.valueField;
	if(!projects)
		return null;
	return(
		<>
			<select id={props.valueField} onChange={(e)=>props.onFilterChange(e)} value={props.defaultValue} className="w-100" >
				<option value="-1" style={{color:'gray'}} > {props.text}</option>
				{projects.map(project=>{
					return(
						<>
							{ tempValue.findIndex((v)=> v==project[displayField]) == -1 && props.filter.findIndex(i=>i==project["prj_status_id"]*1) !=-1?
								<>
									<option value={project[valueField]} >{project[displayField]}</option>
									{tempValue.push(project[displayField]) }
								</>
							:''}
						</>
					)
				})}
			</select>
		</>
	);
}

export const LeadLabel	= (props) =>{
	var UnitProject	=	[];
	props.projects.map(project=>{
		if(UnitProject.findIndex(i=>i.prj_id*1 == project.prj_id*1) == -1){
			UnitProject.push(project);
		}
	});
	
	var _filtered_project	=	UnitProject.filter(p=>p.prj_status_id==props.status && isNumber(p.prj_budget*1));

	var _budget			=	(_filtered_project?_filtered_project.reduce((a, b) => {
		b	=	(isNumber(b.prj_budget*1) ? b.prj_budget*1 :0);
		return a+b;
	},0) :0);
	
	return <div className="border-top rounded-top p-1" style={{ width: '250px', backgroundColor:'lightgray',color:'black'}}>
				{'  '}
				<Badge color="dark" pill className="mr-1">
					{UnitProject? UnitProject.filter(p=>p.prj_status_id==props.status).length :''}
				</Badge>
				{'  '}
				{props.text}
				{'  '}
				{hasAccess('budget')?
				<small className="mr-1 float-right">
					<b>${numberWithCommas(_budget)}</b>
				</small>:''}
				{/*
				<small className="mr-1 float-right">
					${numberWithCommas(Math.round(_budget*0.2))} /
				</small>
					*/}
			</div>
			
}

export const Lead		= (props) =>{
	var projects 		= props.projects;
	var _status 		= props.status;
	const avatarsData = [
	  {
		avatar: require('assets/img/users/66.jpg'),
		name: 'Tom',
		date: '3 month ago',
	  },
	  {
		avatar: require('assets/img/users/0.jpg'),
		name: 'Jenny',
		date: '1 year ago',
	  },
	  {
		avatar: require('assets/img/users/81.jpg'),
		name: 'Sim',
		date: '2 hour ago',
	  },
	];
	var task_priority_color	=	'light';
	
	var UnitProject	=	[];
	if(!projects)
		return null;
	
	const [showProjectTask, setShowProjectTask] = useState(-1);
	
	return(
		<>
			{projects.map(project=>{
				if(UnitProject.findIndex(i=>i*1 == project.prj_id*1) == -1){
					var date0 	=new Date(project.prj_posted_date_full);
					var date1 	=new Date();

					const diffTime0 = (date1 - date0);
					UnitProject.push(project.prj_id);
					return(
					<>
					{project.prj_status_id == _status?
						<>
							<Accordion defaultActiveKey="-1" flush >
								<Accordion.Item eventKey="0">
									<Accordion.Header className="p-0 text-right" style={{backgroundColor: newColorFind(project.category,20)}} >
										<small>
											<b>{project.prj_id}</b>&nbsp;&nbsp;
											<small>{project.prj_title}</small><br />
											<small>{project.prj_address}, {project.prj_city}, {project.prj_postal_code}</small>
											<br/>
											<small><b>{project.prj_posted_date}</b></small> |
											<small className="ml-1">
												<img className="d-none" src={iconDays} width={13} title="Duration" />
												<b> {Math.ceil(diffTime0 / (1000 * 60 * 60 * 24))} Day(s)</b>{'	'}
											</small> 
											{hasAccess('budget')?
											<>|<small className="ml-2" ><b>${ numberWithCommas(project.prj_budget)}</b></small>{' '}</>:''}
											<br/>
											<i>{project.name}{' '}{project.lastname}</i>
											<br/>
											<small>{project.prj_department}</small>
											<br/>
											<small className="bg-warning text-dark" ><b>{project.close_reason}</b></small>
										</small>
									</Accordion.Header>
									<Accordion.Body>
											<div id={project.prj_id? project.prj_id: 0} draggable="false" onDragStart={(event)=>props.drag(event)} >
												<Card>
													<CardBody style={{backgroundColor: newColorFind(project.category,20)}}>
														<CardTitle className="text-capitalize">
															<>
																<b title="Project Type" >{project.category_desc}</b>
																{cookie.get('v-person-role')*1 == 1 || cookie.get('v-person-role')*1 == 11?
																<Button 
																	className="float-right pl-1 pr-1 pt-0 pb-0 m-1"
																	outline
																	size="sm"
																	color="dark"
																	href={"/#/ViewProject/" + project.prj_id }
																	target={'_blank'}
																><small>{project.prj_id}</small></Button>:''}
																	{/*
																<span className="float-right btn btn-primary btn-sm p-0">
																	<a style={{color: 'black'}} target={'_blank'} href={"/#/ViewProject/" + project.prj_id } >{project.prj_id}</a>
																</span>
																	*/}
																<small className="float-right mr-1" >
																	<i 
																	data-prj-id={project.prj_id? project.prj_id: 0} 
																	data-prj-status={project.prj_status? project.prj_status: 0} 
																	data-prj-department={project.prj_department? project.prj_department: 0} 									
																	style={{cursor:'pointer'}} color="dark" 
																	onClick={(e)=>props.onStatusHanlder(e)} 
																	title='Project Status'
																	>
																		{project.prj_status}
																	</i>
																</small>
																<br/>
																<span>{project.prj_title}</span>
																{hasAccess('budget')?
																<span className="float-right" ><small>${ numberWithCommas(project.prj_budget)}</small></span>:''}
															</>
															<br/>
															<span><a target={'_blank'} href={'https://maps.google.com?q=' + project.prj_address + ',' + project.prj_city }><img src={iconLocation} height='16' className="mr-1" /></a></span>
															<small>{project.prj_address}, {project.prj_city}, {project.prj_postal_code}</small>
															{/*
														{project.refered_by_person_id*1==5?
															<span>| <a target={'_blank'} href={'https://trustedpros.ca/members_contractor_search_for_lead_results_view.asp?job_id=' + (project.refered_by_prj_id?project.refered_by_prj_id.replace('HCA',''):'') }><img src={iconT} height='16' /></a></span>
														:''}{'	'}
														{project.refered_by_person_id*1==16?
															<span>| <img src={iconH} height='16' /></span>
														:''}{'	'}
															*/}
															<br/>
														<span className="float-right mr-1">
															<img src={iconDays} width={13} title="Duration" />
															<b> {Math.ceil(diffTime0 / (1000 * 60 * 60 * 24))} Days</b>{'	'}
														</span>
														<span className="float-right mr-1">{project.prj_posted_date}</span>
														{/*
															<h4 style={{display:'inline'}} ><Badge 
																	data-prj-id={project.prj_id? project.prj_id: 0} 
																	data-prj-status={project.prj_status? project.prj_status: 0} 
																	data-prj-department={project.prj_department? project.prj_department: 0} 
																	onClick={(e)=>props.onActionHanlder(e)}
																	href="javascript:(0);" color="dark" className="float-right mr-1">
																	{project.prj_id}
															</Badge></h4>
														*/}
														</CardTitle>										
													</CardBody>
													<CardFooter  style={{backgroundColor: newColorFind(project.category,80)}} >
														<Accordion defaultActiveKey={props.isCollapse} flush onSelect={(e)=>{console.log(project.prj_id)}} >
															<Accordion.Item eventKey="0">
																<Accordion.Header className="p-0 text-right" >
																{/*
																	<HorizontalAvatarList
																	  avatars={projects.filter(p=>p.prj_id==project.prj_id)}
																	  avatarProps={{ size: 40 }}
																	  reversed
																	/>
																*/}
																	<small>Tasks</small>
																</Accordion.Header>
																<Accordion.Body onEntering={(e)=>{setShowProjectTask(project.prj_id)}} >
																{showProjectTask==project.prj_id? <><TaskList isSubTask={false} callback={props.callback} projects={projects} project={project.prj_id} onActionHanlder={(e)=>{props.onActionHanlder(e)}} /></> : ""}
																{/*<TaskList isSubTask={false} callback={props.callback} projects={projects} project={project.prj_id} onActionHanlder={(e)=>{props.onActionHanlder(e)}} />*/}
																	<div className={'border rounded p-1 mt-1'} >
																		<img src={iconAdd} width={16} title="Assign To" 
																			style={{cursor:'pointer'}}
																			data-project-id={project.prj_id} 
																			onClick={(e)=>{
																				var _task	=new Task();
																				_task.openAssignTask(project.prj_id).then(response => {
																					props.callback(response);
																				})
																			}}
																		/>
																	</div>
																</Accordion.Body>
															</Accordion.Item>
														</Accordion>									
													</CardFooter>
													<CardFooter style={{backgroundColor: newColorFind(project.category,80)}} >
														{project.name}{' '}{project.lastname}{'	'}
														{project.person_tel?
															<img style={{cursor:'pointer'}} src={iconPhone} height='16' title={project.person_tel} onClick={()=>{window.location='tel:' + project.person_tel}} />
														:''}
														{'	'}
														{project.email?
															<img style={{cursor:'pointer'}} src={iconEmail} height='16' title={project.email} onClick={()=>{window.location='mailto:' + project.email}}/>
														:''}
														{'	'}									
														{project.has_drawings*1==1?
															<img className="float-right mr-1" src={iconDrawing} height='16' title="Has Drawing" />
														:''}
														{project.has_permit*1==1?
															<img className="float-right mr-1" src={iconPermit} height='16' title="Has Permit" />
														:''}
														{project.has_model*1==1?
															<img className="float-right mr-1" src={iconModel} height='16' title="Has Model" />
														:''}
													</CardFooter>
												</Card>
											</div>
										</Accordion.Body>
									</Accordion.Item>
								</Accordion>									
							<br />
						</>					
					:''}
					</>
					)				
				}
			})}
		</>
	)	
}

export const LeadCompact= (props) =>{
	var projects 		= props.projects;
	var _status 		= props.status;
	
	var UnitProject	=	[];
	
	return(
		<>
			{projects.map(project=>{
				if(UnitProject.findIndex(i=>i*1 == project.prj_id*1) == -1){
					UnitProject.push(project.prj_id);
					return(
					<>
					{project.prj_status_id == _status?
						<>
							#{project.prj_id} - {project.prj_title}
						</>					
					:''}
					</>
					)				
				}
			})}
		</>
	)	
}

export const TaskList	= (props) =>{
	const [isOpen, setIsOpen] 	= useState(false);
	
	var options = {
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
		hour:"2-digit",
		minute:"2-digit"
	};
	
	var today = new Date();
	var date = today.getFullYear() + '-' + (today.getMonth() <= 9 ? '0' + (today.getMonth() + 1) : today.getMonth() + 1) + '-' + (today.getDate() <= 9 ? '0' + today.getDate() : today.getDate());
	var task_priority_color	=	'';
	var card_priority_color	=	'';
	var _performance;
	var _performance_color;
	var date0, date1, date2;
	const getSource	=(_id)=>{
		var _src = require("assets/img/users/avetar.jpg");
		try{
			_src = require('assets/img/users/' + _id + '.jpg');
		}catch(err){}
		return _src;
	}
	
	
	const AvatarWithBadge = withBadge({
		position: 'bottom-left',
		/*color: 'warning',*/
	})(Avatar);
	
	const formatDate = (_date) => {
		
		var options = {
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
			hour:"2-digit",
			minute:"2-digit"
		};
		/*
		var date = (new Date( _date+ ' UTC')).toLocaleString("en", options);
        //const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        //const seconds = String(date.getSeconds()).padStart(2, '0');

        //return `${month}/${day} ${hours}:${minutes}`;
		*/
		return _date;
    }
	
	{/*
	if(props.projects)
		props.projects.map(p=>{
			return(<li>{p.receiver_id}</li>);
		});
	*/}
	var _project	=	props.project;
	return (
		<div className="p-1 mb-1 rounded" >
		{props.projects.filter(project=>project.prj_id==_project && (!project.parent || props.isSubTask)).map(project=>{				
				_performance	= Math.round(100*(project.percent_done/100)/(project.real_hours/60/project.estimate_hours))>100? 100: Math.round(100*(project.percent_done/100)/(project.real_hours/60/project.estimate_hours));
				
				date0 	=new Date(project.start_date_full);
				date1 	=new Date();
				//date2	=new Date(project.expected_end_date);
				date2	=new Date(project.end_date_full);

				const diffTime0 = (date1 - date0);
				const diffDays0 = Math.ceil(diffTime0 / (1000 * 60 * 60 * 24)); 

				const diffTime = (date2 - date1);
				const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 

				const diffTime1 = (date2 - date0);
				const diffDays1 = Math.ceil(diffTime1 / (1000 * 60 * 60 * 24));
			
				const min	=	0;
				const slider=	1;
				const max	= 	(diffDays<0? diffDays0+slider: diffDays1+slider);
				const left	=	(diffDays<0? diffDays1: diffDays0);
				const right	=	(diffDays<0? max+1-left: diffDays);

				const Pmax		=	100;
				const Pleft		=	left*100/max;
				const Pslider	=	1;
				const Pright	=	right*100/max;
				var		color	=	(project.task_status_id*1==7? 'light': (project.task_status_id*1==8? 'warning': (project.task_status_id*1==9? 'info': (project.task_status_id*1==10? 'success': (project.task_status_id*1==17? 'dark': 'light')))))
				var		bgcolor	=	(project.task_status_id*1==7? 'bg-light text-dark': (project.task_status_id*1==8? 'status-start text-dark': (project.task_status_id*1==9? 'status-progress text-dark': (project.task_status_id*1==10? 'status-done text-dark': (project.task_status_id*1==11? 'bg-dark text-light': 'bg-light text-dark')))))
				//var		bgcolor	=	'bg-light text-dark';
		return(
		<>
			<div className={'border rounded p-1 ' + bgcolor + (project.parent*1>0?' ml-2':'') } >
			<Avatar color={'warning'} size={32} className='float-left' src={getSource(project.receiver_id)} title={project.receiver} />
				{project.receiver}
				<Button 
					className="float-right pl-1 pr-1 pt-0 pb-0 m-1"
					outline
					size="sm"
					color="dark"
					data-task-id={project.pt_id?project.pt_id:0}
					data-project-id={project.prj_id? project.prj_id : 0}
					onClick={(e)=>{
						var _task	=new Task();
						_task.ViewTask(project).then(response=>{
							props.callback(response);
						});
					}}
				><small>{project.pt_id}</small></Button>
					{/*
				<span style={{cursor:'pointer'}} > 
					<small className="float-right" >{project.task_status}</small>
				</span>
					*/}
					
					{/*
				<img src={iconDuration} width={16} title="Days You have Worked On" />
				{'	'}<small>{diffDays0}</small>
				<img src={iconDeadline} width={16} title="Dys To Deadline"  />
				{'	'}<small>{diffDays}</small>{'	'}

				<img style={{cursor: 'pointer'}} src={iconSchedule} width={16} title="Estimate Hours" />
				<small>{project.estimate_hours? project.estimate_hours : '-'}</small>{'	'}
				
				<img src={iconHourGlass} width={13} title="Real Minutes" />
				<small>{project.real_hours?project.real_hours*1 : 0} ′</small>{'	'}

				<img src={iconThumbsUp} width={16} title="Percent Done" />
				<small>{project.percent_done?project.percent_done*1 : 0}</small>{'	'}
				
				{!_performance || _performance<60?
					<img src={iconLowPerformance} width={13} title="Performance" />
				:''}
				{_performance>=60 && _performance<80?
					<img src={iconMiddlePerformance} width={13} title="Performance" />
				:''}
				{_performance>=80?
					<img src={iconHightPerformance} width={13} title="Performance" />
				:''}
				<small>{_performance? _performance: 0}</small>
				*/}
				<small
					className="ml-2"
					color={color}
					style={{cursor:'pointer'}}
					data-task-id={project.pt_id?project.pt_id:0} 
					onClick={(e)=>{
						var _task	=new Task();
						_task.viewTaskUpdateForm(project).then(response => {
							props.callback(response);
						})
					}}
					title='Task Type'
				>{project.task_type}</small>
				<small className="p-0 d-block" style={{clear:'both'}} title={project.task}  >
					<Avatar size={16}  src={getSource(project.sender_id)} title='Sender' className="float-left" />
					{project.task?project.task.substring(0, 40) + '...' : ''}
				</small>
				<img className="ml-2" src={iconAddNote} width={16} title="Add Note" 
						style={{cursor:'pointer'}}
						data-task-id={project.pt_id?project.pt_id:0} 
						onClick={(e)=>{
							var _task	=new Task();
							_task.openAddNote(project).then(response => {
								props.callback(response);
							})
						}}
					/>
						{
							project.note_list.split('---').map(n=>{
								if(n!=',' && n!='')
										return(
											<>
												<small className="bg-light text-dark" style={{cursor:'pointer'}} onClick={(e)=>{alert(n.replace(',',''))}} >{n.length>30?n.substring(0,30).replace(',','') + '...' : n.replace(',','')}</small>
											</>
										)
							})
						}
				<br/>
				<img className="ml-2" src={iconAlarm} width={16} title="Add Alarm" 
						style={{cursor:'pointer'}}
						data-task-id={project.pt_id?project.pt_id:0} 
						onClick={(e)=>{
							var _task	=new Task();
							_task.openAlarm(project).then(response => {
								props.callback(response);
							})
						}}
					/>
						{
							project.alarm_list.split('---').map(n=>{
								if(n!=',' && n!='')
										return(
											<>
												<small className="bg-light text-dark" style={{cursor:'pointer'}} onClick={(e)=>{alert(n.replace(',',''))}} >{n.length>30?n.substring(0,30).replace(',','') + '...' : n.replace(',','')}</small>
											</>
										)
							})
						}
					
				<img className="ml-2" src={iconProvideEstimate} width={24} title="Add Estimate/Quote" 
						style={{cursor:'pointer'}}
						onClick={(e)=>{
							var _project	=new Project();
							_project.provideQuote(); 
							/*
							var _invoice	=new Invoice();
							_invoice.openProvideEstimate(project).then(response => {
								props.callback(response);
							})
								*/
						}}
				/>
				{/*
				<img className="ml-2" src={iconPayment} width={24} title="Add Payment" 
						style={{cursor:'pointer'}}
						data-task-id={project.pt_id?project.pt_id:0} 
						onClick={(e)=>{
							var _invoice	=new Invoice();
							_invoice.openReceiveAndPayment(project).then(response => {
								props.callback(response);
							})
						}}
					/>
					*/}
					<small className="d-none" title={project.note_list.split('---').join('\n#\n').replaceAll('<br/>','\n')}><b>Comments {project.note_count}</b></small>{'	'}
				<hr className="p-0 m-0" />
				<span>
					<small className="float-right ml-1 " >
						{project.task_status_id*1==10?
							<>
								<img src={iconDays} width={13} title="Days have Worked On" />
								{'	'}<b>{diffDays1<0?0:diffDays1}</b>
							</>
						:
						<>
							<img src={iconDays} width={13} title="Days have Worked On" />
							{'	'}<b>{diffDays0<0?0:diffDays0}</b>
						</>
						}
					</small>
					<small className="float-right" >{formatDate(project.start_date)}</small> &nbsp; 
					<img src={iconHourGlass} width={13} title="Real Minutes"
						onClick={(e)=>{
							var _taskDetail	=new TaskDetail();
							_taskDetail.ViewTaskDetail(project).then(response => {
								props.callback(response);
							})							
						}}
					/>
					<small>{project.real_hours? Math.floor(project.real_hours*1/60) + ':' + Math.floor(project.real_hours*1%60) : ''} <sup>hrs</sup></small>{'	'} {/* hh:mm */}
				</span>
			</div>
			{props.projects.filter(p=>p.parent==project.pt_id).length>0?
			<Accordion defaultActiveKey={props.isCollapse} flush>
				<Accordion.Item eventKey="0">
					<Accordion.Header className="p-0 text-right" >
						<small>Sub Tasks</small>
					</Accordion.Header>
					<Accordion.Body>
						<TaskList isSubTask={true} callback={props.callback} projects={props.projects.filter(p=>p.parent==project.pt_id)} project={project.prj_id} onActionHanlder={(e)=>{props.onActionHanlder(e)}} />
					</Accordion.Body>
				</Accordion.Item>
			</Accordion>:''}									
		</>
		)})}
		</div>
		);
}

export const Grid		= (props) =>{
	var projects	=	props.projects;
	projects = projects.sort((a,b) => a.prj_status_id - b.prj_status_id)
	var tempValue	=	[];
	return (
		<>
			<div className='Container Flipped'>
				<div className='Content' >
					<table className='grid' >
						<tr>
						{projects.map(project=>{
							return(
								<>
									{ tempValue.findIndex((v)=> v==project["prj_status"]) == -1 ?
											<td className="border-right" status-id={project["prj_status_id"]} status={project["prj_status"]} onDrop={(event)=>props.drop(event)} onDragOver={(event)=>allowDrop(event)} style={props.columns.findIndex(i=>i==project["prj_status_id"]*1) ==-1?{display:'none'}:{}}  >
												<LeadLabel text={project["prj_status"]} projects={projects} status={project["prj_status_id"]} /><br />
												<Lead isCollapse={props.isCollapse} callback={props.callback} projects={projects} status={project["prj_status_id"]} onActionHanlder={(e)=>{props.onActionHanlder(e)}} onStatusHanlder={(e)=>{props.onStatusHanlder(e)}} drag={(e)=>{props.drag(e)}}   />
												<span className="d-none">{tempValue.push(project["prj_status"]) }</span>
											</td>
									:''}
								</>
							)
						})}

						</tr>
					</table>
				</div>
			</div>
		</>		
	)
}

export default ViewProjectsOfPerson;

